import { render, staticRenderFns } from "./FuneraryAccountForm.vue?vue&type=template&id=063997cf&"
import script from "./FuneraryAccountForm.vue?vue&type=script&lang=ts&"
export * from "./FuneraryAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports